(function($) {
    $(document).ready(function() {

        /* Focus search field when search is clicked */
        $('#secondary-menu .link-search').on('click', function() {
            const search_input = $(this).parent().find('input.search-field').first();
            search_input.focus();
        });

        /* 2. Initialize the single lightbox once */
        const lightbox = $.lightbox.init({
            id: 'dynamic-lightbox'
        });

        $('.video-widget').videoLoader({
            platform: 'youtube',
            showInSelf: false,
            autoplay: 1,
            onClick: function(videoHtml) {
                // lightbox.open(videoHtml);

                const $wrapper = $('<div></div>')
                    .addClass('lightbox-video')
                    .css({
                        width: '90%',
                        
                    });
                $wrapper.append(videoHtml);
                lightbox.open($wrapper);
            }
        });

        /**
         * Video laoder
         */

        $('.tribute-video').videoLoader();
        
        $('.section-video:not(.in-lightbox)').videoLoader();
        
        $('.section-video.in-lightbox').videoLoader({
            // platform: 'youtube',
            showInSelf: false,
            autoplay: 1,
            onClick: function(videoHtml) {
                // lightbox.open(videoHtml);

                const $wrapper = $('<div></div>')
                    .addClass('lightbox-video')
                    .css({
                        width: '90%',
                        
                    });
                $wrapper.append(videoHtml);
                lightbox.open($wrapper);
            }
        });

        /* Parallax */
        $('.parallax').parallax();

        /* Animate */
        $('[data-animate]').scrollAnimate({
            once: true,
        });

        /* Gallery lightbox (default, for WordPress galleries) */
        $('.gallery').galleryViewer({
            triggerSelector: '.gallery-item a',
            imageSrcAttr: 'href',
            showArrows: true,
            enableSwipe: true,
            enableKeyboard: true,
            showCaptions: true,
            sameGalleryOnly: true,
            lightboxId: 'gallery-lightbox' // Optional: override default lightbox ID
        });



        /* 3. Article lightbox */
        // $('.article-lightbox').on('click', function(e) {
        //     e.preventDefault();
        //     lightbox.open(
        //         $('#modal1').html() || '',
        //         {
        //             closeSelectors: '.button-close',
        //             closeOnBackdrop: false,
        //         }
        //     )
        // });
    
        /* 5. Products lightbox */
        // $('#products').on('click', '.product-link', function(e){
        //     e.preventDefault();
        //     const $trigger = $(this);
        //     const content = $trigger.closest('.product').find('.product-wrapper').html();
    
        //     lightbox.open(content, {
        //         closeSelectors: '.close-me',
        //         onOpen: function($lightbox) {
        //             const videoLoader = $lightbox.find('.product-video').videoLoader();
        //         }
        //     });
        // });

        // $('.video-loader-2').videoLoader({
        //     target: '#tv',
        //     showInSelf: false, // only in .tv
        //     loadTrigger: function($el, load) {
        //         $el.on('mouseover', function () {
        //             load();
        //         });
        //     }
        // });

        /* 1. Contact form — premade lightbox */
        // const contactFormLightbox = $('#contact-form').lightbox({
        //     id: 'contact',
        //     closeButton: false,
        //     closeSelectors: '.wpcf7-cancel, .lightbox-close',
        //     clearOnClose: false,
        // });
    
        // $('[data-lightbox="contact"]').on('click', function(e) {
        //     e.preventDefault();
        //     contactFormLightbox.open();
        // })

    });
})(jQuery);



/* Document is ready, $ is jQuery */
jQuery(function($) {

});